import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPayments,
  fetchPolicyHolderByInsuree,
  loadingUser,
} from "../../action";
import "../../styles/theme.scss";
import { useTranslation } from "react-i18next";
import { Button, Grid, Typography, Paper } from "@mui/material";
import TableN from "../../reusableComponents/components/generics/TableN";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/system";
import { decodeId } from "../../utils/helper";
import moment from "moment";

const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));
function PaymentTable({ policyHolderId, filter }) {
  const PolicyholderIdStore = localStorage.getItem("policyholderId");
  const SignInSuccess = useSelector((state) => state);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [policyHolderData, setPolicyHolderData] = useState();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageInfo, setPageInfo] = useState();
  const [endCursors, setEndCursors] = useState(null);
  const [startCursors, setStartCursors] = useState(null);
  useEffect(() => {
    dispatch(loadingUser(token));
  }, []);
  // useEffect(() => {
  //     if (policyHolderId?.id) {
  //         dispatch(fetchPayments(policyHolderId?.id))
  //     }
  // }, [policyHolderId, filter])
  console.log("policyHolderId?.id", policyHolderId?.id);
  useEffect(() => {
    if (!!policyHolderId?.id) {
      let params = buildQueryParams({
        filters: filter || {},
        pageSize,
        beforeCursor: endCursors,
        afterCursor: startCursors,
        orderBy: ["-paymentCode"],
        policyHolderId: policyHolderId?.id,
      });
      if (policyHolderId?.id) {
        dispatch(fetchPayments(params));
      }
    }
  }, [policyHolderId?.id, page, pageSize]);
  useEffect(() => {
    if (SignInSuccess?.profileReducer?.paymentData) {
      setPolicyHolderData(SignInSuccess?.profileReducer?.paymentData);
      setPageInfo(
        SignInSuccess?.profileReducer?.paymentDataPageInfo.totalCount
      );
      setStartCursors(
        SignInSuccess?.profileReducer?.paymentDataPageInfo?.endCursor
      );
      setEndCursors(
        SignInSuccess?.profileReducer?.paymentDataPageInfo?.startCursor
      );
    }
  }, [SignInSuccess]);
  // useEffect(() => {
  //     const afterCursor = pageInfo?.endCursor;
  //     const beforeCursor = pageInfo?.startCursor;
  //     if (policyHolderId?.id) {
  //         dispatch(fetchPayments(policyHolderId?.id, pageSize, afterCursor, beforeCursor));
  //     }
  // }, [page, pageSize]);
  const payemntType = [
    {
      value: "B",
      label: t("Bank Transfer"),
    },
    {
      value: "C",
      label: t("Cash"),
    },
    {
      value: "M",
      label: t("Mobile Phone"),
    },
    {
      value: "BC",
      label: t("Bank Cheque"),
    },
  ];

  const formatDateRange = (dateFrom, dateTo) => {
    const startDate = moment(dateFrom);
    const endDate = moment(dateTo);

    const startMonthYear = startDate.format("MMM YYYY");
    const endMonthYear = endDate.format("MMM YYYY");
    if (dateFrom) {
      if (
        startDate.isSame(endDate, "month") &&
        startDate.isSame(endDate, "year")
      ) {
        return startMonthYear;
      } else {
        return `${startMonthYear} - ${endMonthYear}`;
      }
    } else {
      return null;
    }
  };
  const headers = () => {
    var h = [
      // "Code",
      t("paymentId"),
      t("Request Date"),
      t("declarationId"),
      t("period"),
      t("policyholderName"),
      // t("Current Due"),
      // t("Previous Due"),
      // t("Declaration Penalty"),
      // t("Payment Penalty"),
      t("Total Due with Penalty"),
      t("typeOfPayment"),
      t("Status"),
    ];
    return h;
  };
  const PAYMENT_STATUS = {
    "-1": "Rejected",
    "-2": "Rejected",
    "-3": "Rejected",
    1: "Created",
    2: "Pending",
    3: "Processing",
    4: "Overdue",
    5: "Approved",
  };

  function getLabelByValue(value) {
    const payment = payemntType.find(p => p.value === value);
    return payment ? payment.label : null;
  }

  const itemFormatters = () => {
    var row = [
      (policyHolderInsuree) =>
        !!policyHolderInsuree.paymentCode
          ? policyHolderInsuree.paymentCode
          : "",
      (policyHolderInsuree) => {
        const dateValidFrom = new Date(policyHolderInsuree.requestDate);
        return dateValidFrom.toLocaleDateString("en-GB");
      },
      (policyHolderInsuree) =>
        !!policyHolderInsuree.contract.code
          ? policyHolderInsuree.contract.code
          : "",
      (policyHolderInsuree) =>
        formatDateRange(
          policyHolderInsuree.contract?.dateValidFrom,
          policyHolderInsuree.contract?.dateValidTo
        ),
      (policyHolderInsuree) =>
        policyHolderInsuree.contract?.policyHolder?.tradeName,
    //   (policyHolderInsuree) =>
    //     !!policyHolderInsuree.expectedAmount
    //       ? policyHolderInsuree.expectedAmount
    //             : "",
          (policyHolderInsuree) => `XAF ${policyHolderInsuree.expectedAmount}`,   
          (policyHolderInsuree) => getLabelByValue(policyHolderInsuree.typeOfPayment),   
    //   (policyHolderInsuree) =>
    //     !!policyHolderInsuree.parentPendingPayment
    //       ? policyHolderInsuree.parentPendingPayment
    //       : "",
    //   (policyHolderInsuree) =>
    //     !!policyHolderInsuree.contractPenaltyAmount
    //       ? policyHolderInsuree.contractPenaltyAmount
    //       : "",
    //   (policyHolderInsuree) =>
    //     !!policyHolderInsuree.parentPaymentPenalty
    //       ? policyHolderInsuree.parentPaymentPenalty
    //       : "",
    //   (policyHolderInsuree) =>
        // !!policyHolderInsuree.totalAmount
        //   ? policyHolderInsuree.totalAmount
        //   : "",
      (policyHolderInsuree) => {
        const status = PAYMENT_STATUS[policyHolderInsuree?.status];
        let color;
        switch (status) {
          case "Approved":
            color = "green";
            break;
          case "Rejected":
            color = "red";
            break;
          case "Created":
            color = "black";
            break;
          case "Processing":
            color = "blue";
            break;
          case "Paid":
            color = "blue";
            break;
          default:
            color = "orange";
        }
        return status ? (
          <span style={{ fontWeight: "bold", color: color }}>{t(status)}</span>
        ) : (
          ""
        );
      },
    ];

    return row;
  };
  const handleRowDoubleClick = (rowData) => {
    navigate(`/portal/paymentform/:id=${rowData.uuid}`);
  };
  const handleRowsPerPageChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0); // Reset to the first page when changing page size
    setEndCursors(null);
    setStartCursors(null);
  };
  const handleNavigation = (direction) => {
    if (direction === "forward") {
      setEndCursors(null);
    } else if (direction === "backward") {
      setStartCursors(null);
    }
  };
  const buildQueryParams = (state) => {
    let params = Object.keys(state.filters)
      .filter((f) => !!state.filters[f]["filter"])
      .map((f) => state.filters[f]["filter"]);
    // params.push(`isDeleted: false`);
    if (!state.beforeCursor && !state.afterCursor) {
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.afterCursor) {
      params.push(`after: "${state.afterCursor}"`);
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.beforeCursor) {
      params.push(`before: "${state.beforeCursor}"`);
      params.push(`last: ${state.pageSize}`);
    }
    if (!!state.orderBy) {
      params.push(`orderBy: ["${state.orderBy}"]`);
    }
    if (!!state.policyHolderId) {
      params.push(
        `additionalFilter:"{\\"policyHolder\\":\\"${decodeId(
          state.policyHolderId
        )}\\"}"`
      );
    }
    return params;
  };
  return (
    <Grid container>
      {/* <TableN/> */}
      <Grid item xs={12}>
        <StyledPaper>
          <StyledPaperHeader container alignItems="center" direction="row">
            <Grid item alignItems="center">
              <Typography variant="h6">
                {t("PaymentList")}-{pageInfo}
              </Typography>
            </Grid>
          </StyledPaperHeader>
          <TableN
            module="insuree"
            headers={headers()}
            itemFormatters={itemFormatters()}
            items={policyHolderData ? policyHolderData : []}
            withSelection={"single"}
            withPagination={true}
            rowsPerPageOptions={[10, 50, 100]}
            defaultPageSize={5}
            page={page}
            pageSize={pageSize}
            count={pageInfo}
            onChangePage={(event, newPage) => {
              setPage(newPage);
              handleNavigation(newPage > page ? "forward" : "backward");
            }}
            onChangeRowsPerPage={handleRowsPerPageChange}
            onDoubleClick={handleRowDoubleClick}
          />
        </StyledPaper>
      </Grid>
    </Grid>
  );
}

export default PaymentTable;
